// Generated by scripts/login_captcha/emit.mjs; edit the TypeScript source.
let pending;
let loadedUrl;
// One lazy script for all login entries. No polling or per-render network call.
export function loadCaptchaSdk(scriptUrl) {
    if (loadedUrl && loadedUrl !== scriptUrl)
        return Promise.reject(new Error('CAPTCHA configuration changed'));
    if (pending)
        return pending;
    loadedUrl = scriptUrl;
    pending = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        let settled = false;
        const finish = (failed) => {
            if (settled)
                return;
            settled = true;
            clearTimeout(timer);
            script.onload = null;
            script.onerror = null;
            const sdk = window.AwsWafIntegration;
            if (failed || !sdk?.getToken) {
                script.remove();
                reject(new Error('CAPTCHA unavailable'));
            }
            else
                resolve(sdk);
        };
        const timer = setTimeout(() => finish(true), 12000);
        script.async = true;
        script.src = scriptUrl;
        script.onload = () => finish(false);
        script.onerror = () => finish(true);
        document.head.appendChild(script);
    }).catch(error => { pending = undefined; loadedUrl = undefined; throw error; });
    return pending;
}
